import SearchIcon from '@/components/icons/SearchIcon.vue';
import AppButton from "@/components/AppButton.vue";
import StrokedPlusIcon from "@/components/icons/StrokedPlusIcon.vue";
export default {
  name: 'EmptySegments',
  components: {
    SearchIcon,
    AppButton,
    StrokedPlusIcon
  },
  props: {
    big: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      this.$router.push('/cogs-data');
    }
  }
};